module.exports = __webpack_public_path__ + "static/assets/7c5a16e0627c64fd62ec597bb72b879d.mp3";